import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Boxes = () => {
  const navigate = useNavigate();
  const dashboardCounts = useSelector(
    (state) => state.dashboard.dashboardCounts || {}
  );
  const dashboardLinkedCounts = useSelector(
    (state) => state.dashboard.dashboardLInkedCounts || {}
  );
  //console.log('test console added');

  return (
    <>
      <h1 className="desk-head"> ABHA </h1>{" "}
      <Row gutter={[20, 30]}>
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/abha-linked")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                ABHA Address Linked{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              {" "}
              {/* <div className='priceText'>{totalFaqs || 0}</div>    */}{" "}
              <div className="priceText">
                {" "}
                {dashboardCounts?.healthIdLinkedCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/abha-linked-log")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                ABHA Address Created / Retrieved and Linked Log{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              {" "}
              {/* <div className='priceText'>{totalFaqs || 0}</div>    */}{" "}
              <div className="priceText">
                {" "}
                {dashboardCounts?.healthIdCreatedRetrievedLinkedCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>
        </Col>
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/report-list")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">Care Context </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              {" "}
              {/* <div className='priceText'>{totalFaqs || 0}</div>    */}{" "}
              <div className="priceText">
                {" "}
                {dashboardCounts?.healthIdCreatedRetrievedLinkedCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>
        </Col>
      </Row>
      <h1 className="desk-head">HIP</h1>
      <Row gutter={[20, 30]}>
         <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/audit-logs")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
               Audit Log{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.auditLogs || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        {/* <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-data-request-received")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Total Care Contexts linked{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.dataRequestReceivedCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col> */}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip/data-shared")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                User Linked Care Contexts{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.UserLinkedCareContexts || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip/linked-care-contexts")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                HIP linked Care Contexts{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.HIPLinkedCareContexts || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>
        </Col>
        {/* <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-user-inisiated")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                User Initiated{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.LinkRecordApiRequestCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-log")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Record Linked Log{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.recordLinkedLogsCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        */}
        {/* <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-consent-grant")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Consent Grant Logs{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.consentGrantLogsCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col> */}
      </Row>
      {/* <Row gutter={[20, 30]}>
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-data-request-received")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Data Request Received{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.dataRequestReceivedCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip/data-shared")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Data Shared{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.dataSharedCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-data-request-pending")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Data Request Pending{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.dataRequestPendingCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>
        </Col>
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-user-inisiated")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                User Initiated{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.LinkRecordApiRequestCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-log")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Record Linked Log{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.recordLinkedLogsCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>{" "}
        <Col span={8}>
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            onClick={() => navigate("/hip-consent-grant")}
          >
            <div className="flex justify-content-between align-item-center">
              <div className="relative boxHeadingRisk fw-600">
                {" "}
                Consent Grant Logs{" "}
              </div>{" "}
            </div>{" "}
            <div className="flex justify-content-end align-item-center">
              <div className="priceText">
                {" "}
                {dashboardCounts?.hip?.consentGrantLogsCount || 0}{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </Col>
      </Row> */}
    </>
  );
};

export default Boxes;
